import React from 'react'
import TagsComp from '../utils/TagsComp';
import { useTranslation } from 'react-i18next';
import {
  Safe1Icon,
  Safe2Icon,
  Safe3Icon,
  Safe4Icon,
  Safe5Icon,
} from '../../assets/Icons/Security/SecurityIcon';
import { useWindowSize } from '../../Hooks/useWindowSize';

const SecurityStandard = () => {
  const { t } = useTranslation();
  const { width: windowWidth } = useWindowSize();
  const isMobileView = windowWidth <= 600;

  return (
    <div className="clip-path-class bg-LightBgSecondary py-[180px] max_xl:py-[140px] max_md:py-[100px]">
      <div className="max-w-[1240px] max_xl:max-w-[980px] m-auto max_md:px-10 max_sm:px-5">
        <TagsComp
          text={t('SecurityStandards')}
          color="#00A0FC"
          borderColor="#00A0FC"
        />
        <div className="flex max_md:flex-col justify-between mt-6 max_xl:gap-8 max_md:gap-[60px] max_600:gap-10">
          <div className="max-w-[450px] max_md:max-w-[100%] flex flex-col gap-6 max_xl:max-w-[420px]">
            <p className="text50">{t('SafeConfidentialInfo')}</p>
            <p className="subHeadingText font-medium text-LightTextParagraph max_md:text-headingNormal max_sm:text-textSmall">
              {t('SafeConfidentialInfoText')}
            </p>
          </div>
          <div className="flex gap-6 max_sm_380:flex-col max_600:gap-2">
            <div className="flex flex-col gap-6 mt-2 max_600:gap-3">
              <div className="bg-white p-4 max_sm:p-[10px] rounded-xl flex gap-[14px] max_sm:gap-3 max-w-[286px] items-center">
                <div>
                  <Safe1Icon
                    style={{
                      width: isMobileView ? '30' : '',
                      height: isMobileView ? '30' : '',
                    }}
                  />
                </div>
                <p className="subParagraphText max_600:text-textExtraSmall max_sm:leading-[22px] max_sm:tracking-[-1px] tracking-[-1px] text-LightPrimary">
                  {t('SafeText1')}
                </p>
              </div>
              <div className="bg-white p-4 max_sm:p-[10px] rounded-xl flex gap-[14px] max_sm:gap-3 max-w-[286px] items-center">
                <div>
                  <Safe2Icon
                    style={{
                      width: isMobileView ? '30' : '',
                      height: isMobileView ? '30' : '',
                    }}
                  />
                </div>
                <p className="subParagraphText max_600:text-textExtraSmall max_sm:leading-[22px] max_sm:tracking-[-1px] tracking-[-1px] text-LightPrimary">
                  {t('SafeText2')}
                </p>
              </div>
              <div className="bg-white p-4 max_sm:p-[10px] rounded-xl flex gap-[14px] max_sm:gap-3 max-w-[286px] items-center">
                <div>
                  <Safe3Icon
                    style={{
                      width: isMobileView ? '30' : '',
                      height: isMobileView ? '30' : '',
                    }}
                  />
                </div>
                <p className="subParagraphText max_600:text-textExtraSmall max_sm:leading-[22px] max_sm:tracking-[-1px] tracking-[-1px] text-LightPrimary">
                  {t('SafeText3')}
                </p>
              </div>
            </div>
            <div className="flex flex-col gap-6 max_md:justify-center max_600:gap-3">
              <div className="bg-white p-4 max_sm:p-[10px] rounded-xl flex gap-[14px] max_sm:gap-3 max-w-[286px]  items-center">
                <div>
                  <Safe4Icon
                    style={{
                      width: isMobileView ? '30' : '',
                      height: isMobileView ? '30' : '',
                    }}
                  />
                </div>
                <p className="subParagraphText max_600:text-textExtraSmall max_sm:leading-[22px] max_sm:tracking-[-1px] tracking-[-1px] text-LightPrimary">
                  {t('SafeText4')}
                </p>
              </div>
              <div className="bg-white p-4 max_sm:p-[10px] rounded-xl flex gap-[14px] max_sm:gap-3 max-w-[286px] items-center">
                <div>
                  <Safe5Icon
                    style={{
                      width: isMobileView ? '30' : '',
                      height: isMobileView ? '30' : '',
                    }}
                  />
                </div>
                <p className="subParagraphText max_600:text-textExtraSmall max_sm:leading-[22px] max_sm:tracking-[-1px] tracking-[-1px] text-LightPrimary">
                  {t('SafeText5')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SecurityStandard